export default "__VITE_ASSET__CMIXo9xA__"